module.exports = __webpack_public_path__ + "static/media/NA.e60de663.svg";